<template>
 <div class="search-type-div">
    <Card style="height:100%">
      <!-- 查询栏 -->
      <Row>
         <Col :span="3" style="padding-right: 0.5em">
          <Select
            placeholder="请选择公报类型"
            size="large"
            clearable
            v-model="formData.type"
            @on-change="queryData"
          >
            <Option v-for="(value, key) in types" :key="key" :value="key">{{value}}</Option>
          </Select>
        </Col>
        <Col :span="8">
          <Input
            search enter-button
            size="large"
            v-model="formData.fileName"
            placeholder="请输入公告名称"
            @on-search="queryData"
          ></Input>
        </Col>
        <Col :span="24" class="toolbar">
          <Button type="success" size="large" @click="onAdd">&nbsp;添加&nbsp;</Button>
          <Button type="success" size="large" @click="deleteArry">&nbsp;删除&nbsp;</Button>
        </Col>
      </Row>
      <br />
      <!-- 内容栏 -->
      <Row>
          <Table border :columns="columns" :data="data" ref="table">
            <template slot-scope="{ row }" slot="action">
              <Button type="primary" size="small" style="margin-left: 5px" @click="onEdit(row)">编辑</Button>
            </template>
          </Table>
          <br />
          <Page
            :current.sync="current"
            :total="total"
            :page-size="pageSize"
            @on-change="queryData"
            show-total
          />

      </Row>
    </Card>
  </div>
</template>

<script>
import {queryPageList,deleteByIds,} from "@/api/systemManagement/bulletin";
import { TYPES } from "./components/bulletinConfig";
import { deepCopy } from "@/utils/miscUtil";
export default {
   name: "bulletinConfig",
  data() {
    return {
       types: TYPES,
      columns: [
         {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "公告类型",
          key: "type",
          width: 230,
          align: "center",
           render(h, { row }) {
            return h("span", TYPES[row.type]);
          }
        },
        {
          title: "文件标题",
          key: "fileTitle",
          width: 280,
          align: "center"
        },
        {
          title: "文件名称",
          key: "fileName",
          width: 280,
          align: "center"
        },
        {
            title: "责任编辑",
            key: "redactor",
            width: 230,
            align: "center"
          },
        {
          title: "创建时间",
          key: "createTime",
          minWidth: 250,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
         
          align: "center",
          // fixed: "right"
        }
      ],
      // 数据项
      current: 1,
      pageSize: 10,
      total: 0,
      data: [],
      // 查询表单
      formData: {
        fileName: "",
        type:""
      }
    };
  },
  created() {
    this.queryData();
  },
  methods: {
        /**
     * 请求数据
     */
      queryData() {
        queryPageList(
          this.current,
          this.pageSize,
          deepCopy(this.formData)
        ).then(res => {
          const { pages, records, total, current } = res;
          this.data = records;
          this.total = total;
          // 到达尾页
          if ((records.length == 0) & (pages > 0)) {
            this.current = 1;
            this.queryData();
          }
        });
    },
    /**
     * 添加
     */
    onAdd() {
      this.$router.push("/systemManagement/addBulletin");
    },
    // 编辑
    onEdit(row) {
     this.$router.push({path: '/systemManagement/editBulletin', query: {id:row.id}});
     
    },
    //删除
    deleteArry () {
      this.ids = [];
      let data = this.$refs.table.getSelection();
      if (data.length == 0) {
        this.$Message.info("请先选择需要删除的公报");
        return;
      }
      data.forEach(element => {
        this.ids.push(element.id);
      });
      this.$Modal.confirm({
        title: "确认框",
        content: "确认删除公报？",
        onOk: () => {
          deleteByIds(this.ids).then(res => {
            if (res.data.flag) {
              this.queryData();
            }
          });
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
.search-type-div {
  .toolbar {
    text-align: right;
    > * {
      margin-left: 0.5em;
    }
  }
  .tree {
    max-height: 30em;
    overflow: auto;
  }
}
</style>
